import React from 'react'
import { Clock, AlertTriangle, Users, Zap } from 'lucide-react'

const FOMO: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-red-50 to-orange-50">
      <div className="container-width section-padding">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-8 animate-pulse">
            <AlertTriangle className="w-10 h-10 text-red-500" />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-red-500">한정</span> 무료 공개
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-red-200 mb-12">
            <div className="text-center space-y-6">
              <p className="text-xl md:text-2xl text-gray-800 leading-relaxed">
                "광고 없이 오직 <strong className="text-red-500">입소문</strong>으로만"
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed">
                이 페이지를 다시 찾기는 어렵습니다
              </p>
              
              <div className="bg-red-50 p-6 rounded-2xl border border-red-200">
                <p className="text-lg text-gray-800 leading-relaxed">
                  AI 시스템 운영 비용으로
                  <br />
                  <strong className="text-red-600">무료 구독은 선착순 제한됩니다</strong>
                </p>
              </div>
              
              <p className="text-xl font-bold text-red-600">
                지금이 마지막 기회일 수 있습니다
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-orange-200 text-center">
              <Clock className="w-12 h-12 text-orange-500 mx-auto mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">시간 절약</h3>
              <p className="text-gray-600">30분 → 3분으로 단축</p>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-blue-200 text-center">
              <Users className="w-12 h-12 text-blue-500 mx-auto mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">글로벌 인사이트</h3>
              <p className="text-gray-600">해외 커뮤니티 실시간 추적</p>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-green-200 text-center">
              <Zap className="w-12 h-12 text-green-500 mx-auto mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">완벽 번역</h3>
              <p className="text-gray-600">전문 용어까지 정확하게</p>
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="inline-block bg-gradient-to-r from-red-500 to-orange-500 text-white p-6 rounded-2xl">
              <p className="text-lg font-bold mb-2">⚡ 지금 구독하면</p>
              <p className="text-sm">첫 번째 뉴스레터를 24시간 내에 받아보실 수 있습니다</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FOMO
